/* eslint-disable no-console */
import { put, takeEvery, select } from 'redux-saga/effects';
import { sendMessages, getMessages as getMessagesRequest } from 'api/candidates';
import setLoading from 'actions/loading';
import { RecruiterEvent } from 'types/pusher';
import { setMessages, getMessages, startSendMessage, resolveSendMessage } from './actions';

export function* getMessagesSaga(action: any) {
  const { token } = yield select(state => state.user);
  const { candidateId } = action.payload;
  const filter = { where: { refId: candidateId, event: RecruiterEvent.CANDIDATE_NOTE } };

  try {
    yield put(setLoading(true));
    const messages = yield getMessagesRequest(token, filter);
    yield put(setMessages(messages.data));
    yield put(setLoading(false));
  } catch (error) {
    console.error(error.response);
  }
}

export function* sendMessagesSaga(action: any) {
  const { token } = yield select(state => state.user);
  const { note, candidateId } = action.payload;

  try {
    yield sendMessages(note, candidateId, token);

    yield put(resolveSendMessage());
  } catch (error) {
    yield put(resolveSendMessage(error.response));
  }
}

export default function* sendMessagesSagas() {
  yield takeEvery(startSendMessage, sendMessagesSaga);
  yield takeEvery(getMessages, getMessagesSaga);
}
